import { Component, inject, OnInit, signal } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { map } from 'rxjs';
import { Favorite } from 'src/app/state/user/favorites/models/favorites.response';
import { FavoritesFacade } from 'src/app/state/user/favorites/favorites.facade';
import { ActivatedRoute, Router } from '@angular/router';
import { convertToBoolean } from '../../_core/utils/convert-to-boolean';
@Component({
  selector: 'app-favourites',
  templateUrl: './favourites.component.html',
  styleUrls: ['./favourites.component.scss'],
})
export class FavouritesComponent implements OnInit {
  private readonly router = inject(Router);

  readonly MAX_ITEMS_PER_REQUEST = 5;
  readonly showBackButton = signal<boolean>(false);

  section = 'favourites';
  hasLoadMore: boolean;
  loadingMoreItems = false;

  readonly favoriteFacade = inject(FavoritesFacade);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly isLoading$ = this.favoriteFacade.isLoading$;
  readonly paginatedFavorites$ = this.favoriteFacade.paginatedFavorites$;
  readonly emptyFavorites$ = this.paginatedFavorites$.pipe(
    map((paginatedFavorites) => !paginatedFavorites || !paginatedFavorites?.items.length)
  );
  readonly showDeleteAllFavoritesDialog = signal<boolean>(false);

  constructor(public userService: UserService) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      if (params.has('showReturnButton')) {
        this.showBackButton.set(convertToBoolean(params.get('showReturnButton')));
      } else {
        this.showBackButton.set(true);
      }
    });

    this.favoriteFacade.getPaginatedFavorites();
  }

  onFavoriteRemoved(favorite: Favorite) {
    this.favoriteFacade.deleteFavorite(favorite.recordId);
  }

  loadMore() {
    const offset = this.favoriteFacade.paginatedFavorites.items.length;

    this.favoriteFacade.getPaginatedFavorites(this.MAX_ITEMS_PER_REQUEST, offset);
  }

  goBack() {
    history.back();
  }

  addTitles() {
    this.router.navigate(['/search', 'lists', 'favorites']);
  }

  removeAllFavorites() {
    this.showDeleteAllFavoritesDialog.set(false);
    this.favoriteFacade.deleteAllFavorites().subscribe(() => {
      this.router.navigate(['/user/lists']);
    });
  }
}
